// Components
import Text from 'components/common/Text';
import Image from 'next/image';
import ErrorIcon from '@mui/icons-material/Error';

// Libs
import Translation from 'libs/Translation';

const WeeklySchedule = ({ center, mobileView }) => {

    return (
        <div className="box padding-24">
            <div className='row-flex flex-title'>
                {mobileView ?
                <Image
                    src="/nextasset/images/center/icon-4.png"
                    width={28}
                    height={28}
                    alt="text-icon"
                />
                :
                <Image
                    src="/nextasset/images/center/icon-4.png"
                    width={32}
                    height={32}
                    alt="text-icon"
                />
                }
                <Text 
                    color="#0D2439"
                    className="title"
                >
                    {Translation.t('title.work-times')}
                </Text>
            </div>
            <div className='work-time-container'>
                {center.WeeklySchedule.map((i, index) => (
                <div 
                    className='work-time-box'
                    key={index}
                >
                    <span className='day'>
                       {Translation.t(`label.${i.Day}`)}
                    </span>
                    <span className='time'>
                       {Translation.n(i.Open)} {Translation.t('text.to')} {Translation.n(i.Close)}
                    </span>
                </div>
                ))}
            </div>
            {!center.OnHolidayStatus &&
            <div className='notif'>
                <ErrorIcon style={{width: '20px', height: '20px'}} />
                {Translation.t('text.close-on-holiday')}
            </div>
            }
        </div>
    )
}
export default WeeklySchedule;